/**
 * PageLoader - Content skeleton loader for lazy-loaded pages.
 * Shows a page-shaped skeleton layout instead of a branded spinner.
 * This provides better perceived performance and avoids the "broken page" impression.
 */
export default function PageLoader() {
  return (
    <div className="min-h-[80vh] page-enter">
      {/* Hero skeleton */}
      <div className="bg-sand/50 h-[40vh] sm:h-[50vh] flex items-end">
        <div className="container pb-12 pt-24 space-y-4">
          <div className="skeleton-shimmer h-4 w-32 rounded" />
          <div className="skeleton-shimmer h-10 w-3/4 max-w-lg rounded" />
          <div className="skeleton-shimmer h-5 w-2/3 max-w-md rounded" />
          <div className="skeleton-shimmer h-12 w-48 rounded-lg mt-4" />
        </div>
      </div>
      {/* Content skeleton */}
      <div className="container py-12 space-y-8">
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {[1, 2, 3].map((i) => (
            <div key={i} className="space-y-3">
              <div className="skeleton-shimmer aspect-[16/10] rounded-lg" />
              <div className="skeleton-shimmer h-5 w-3/4 rounded" />
              <div className="skeleton-shimmer h-4 w-full rounded" />
              <div className="skeleton-shimmer h-4 w-2/3 rounded" />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
